// extracted by mini-css-extract-plugin
export default {"content":"verificationSuccess_content__ITwI9","icon":"verificationSuccess_icon__e7GZp","message":"verificationSuccess_message__+b3-6","modal":"verificationSuccess_modal__0CkFr"};